// Generated by purs version 0.14.3
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Error_Util = require("../Control.Error.Util/index.js");
var Control_Lazy = require("../Control.Lazy/index.js");
var Control_Monad_Error_Class = require("../Control.Monad.Error.Class/index.js");
var Control_Monad_Except = require("../Control.Monad.Except/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Control_Monad_Fork_Class = require("../Control.Monad.Fork.Class/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Control_Parallel_Class = require("../Control.Parallel.Class/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Eq_Generic = require("../Data.Eq.Generic/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Lens_Lens = require("../Data.Lens.Lens/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Show_Generic = require("../Data.Show.Generic/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic = require("../Foreign.Generic/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Foreign_Index = require("../Foreign.Index/index.js");
var Foreign_NullOrUndefined = require("../Foreign.NullOrUndefined/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var Network_Ethereum_Core_BigNumber = require("../Network.Ethereum.Core.BigNumber/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Core_Signatures = require("../Network.Ethereum.Core.Signatures/index.js");
var Network_Ethereum_Web3_Types_TokenUnit = require("../Network.Ethereum.Web3.Types.TokenUnit/index.js");
var Simple_JSON = require("../Simple.JSON/index.js");
var Web3Par = function (x) {
    return x;
};
var Web3 = function (x) {
    return x;
};
var Succeeded = (function () {
    function Succeeded() {

    };
    Succeeded.value = new Succeeded();
    return Succeeded;
})();
var Failed = (function () {
    function Failed() {

    };
    Failed.value = new Failed();
    return Failed;
})();
var TransactionOptions = function (x) {
    return x;
};
var SyncStatus = function (x) {
    return x;
};
var RpcError = function (x) {
    return x;
};
var Rpc = (function () {
    function Rpc(value0) {
        this.value0 = value0;
    };
    Rpc.create = function (value0) {
        return new Rpc(value0);
    };
    return Rpc;
})();
var RemoteError = (function () {
    function RemoteError(value0) {
        this.value0 = value0;
    };
    RemoteError.create = function (value0) {
        return new RemoteError(value0);
    };
    return RemoteError;
})();
var ParserError = (function () {
    function ParserError(value0) {
        this.value0 = value0;
    };
    ParserError.create = function (value0) {
        return new ParserError(value0);
    };
    return ParserError;
})();
var NullError = (function () {
    function NullError() {

    };
    NullError.value = new NullError();
    return NullError;
})();
var Response = function (x) {
    return x;
};
var Request = function (x) {
    return x;
};
var FilterId = function (x) {
    return x;
};
var FalseOrObject = function (x) {
    return x;
};
var ContinueEvent = (function () {
    function ContinueEvent() {

    };
    ContinueEvent.value = new ContinueEvent();
    return ContinueEvent;
})();
var TerminateEvent = (function () {
    function TerminateEvent() {

    };
    TerminateEvent.value = new TerminateEvent();
    return TerminateEvent;
})();
var NullStorageError = (function () {
    function NullStorageError(value0) {
        this.value0 = value0;
    };
    NullStorageError.create = function (value0) {
        return new NullStorageError(value0);
    };
    return NullStorageError;
})();
var BlockNumber = function (x) {
    return x;
};
var Latest = (function () {
    function Latest() {

    };
    Latest.value = new Latest();
    return Latest;
})();
var BN = (function () {
    function BN(value0) {
        this.value0 = value0;
    };
    BN.create = function (value0) {
        return new BN(value0);
    };
    return BN;
})();
var Filter = function (x) {
    return x;
};
var Change = function (x) {
    return x;
};
var Transaction = function (x) {
    return x;
};
var TransactionReceipt = function (x) {
    return x;
};
var Block = function (x) {
    return x;
};
var writeFHexString = new Simple_JSON.WriteForeign(function (v) {
    return Foreign_Generic_Class.encode(Network_Ethereum_Core_BigNumber.encodeBigNumber)(v);
});
var unWeb3 = function (v) {
    return v;
};
var unFalseOrObject = function (v) {
    return v;
};
var showBlockNumber = Network_Ethereum_Core_BigNumber.showBigNumber;
var readFalseOrObject = function (f) {
    return function (value) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Monad_Error_Class.catchError(Control_Monad_Except_Trans.monadErrorExceptT(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(function (v) {
            return true;
        })(Foreign.readBoolean(Data_Identity.monadIdentity)(value)))(function (v) {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(false);
        }))(function (isBool) {
            if (isBool) {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Maybe.Nothing.value);
            };
            return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(function ($252) {
                return FalseOrObject(Data_Maybe.Just.create($252));
            })(f(value));
        });
    };
};
var readFHexString = new Simple_JSON.ReadForeign((function () {
    var $253 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(BlockNumber);
    var $254 = Foreign_Generic_Class.decode(Network_Ethereum_Core_BigNumber.decodeBigNumber);
    return function ($255) {
        return $253($254($255));
    };
})());
var plusParWeb3 = Control_Monad_Reader_Trans.plusReaderT(Effect_Aff.plusParAff);
var ordBlockNumber = Network_Ethereum_Core_BigNumber.ordBigNumber;
var newtypeTxReceipt = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeTransactionOptions = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeTransaction = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeSyncStatus = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeRPCError = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeFilter = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeFalseOrObj = new Data_Newtype.Newtype(function () {
    return undefined;
});
var showFalseOrObj = function (dictShow) {
    return new Data_Show.Show(function (x) {
        return "(FalseOrObject " + (Data_Show.show(Data_Maybe.showMaybe(dictShow))(Data_Newtype.unwrap()(x)) + ")");
    });
};
var newtypeChange = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeBlockNumber = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeBlock = new Data_Newtype.Newtype(function () {
    return undefined;
});
var monadWeb3 = Control_Monad_Reader_Trans.monadReaderT(Effect_Aff.monadAff);
var monadThrowWeb3 = Control_Monad_Reader_Trans.monadThrowReaderT(Effect_Aff.monadThrowAff);
var monadRecWeb3 = Control_Monad_Reader_Trans.monadRecReaderT(Effect_Aff.monadRecAff);
var monadReaderWeb3 = Control_Monad_Reader_Trans.monadReaderReaderT(Effect_Aff.monadAff);
var monadForkWeb3 = new Control_Monad_Fork_Class.MonadFork(function () {
    return Effect_Aff.functorFiber;
}, function () {
    return monadWeb3;
}, (function () {
    var $256 = Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkReaderT(Control_Monad_Fork_Class.monadForkAff));
    return function ($257) {
        return Web3($256(unWeb3($257)));
    };
})(), (function () {
    var $258 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(Effect_Aff.monadAff);
    var $259 = Control_Monad_Fork_Class.join(Control_Monad_Fork_Class.monadForkAff);
    return function ($260) {
        return Web3($258($259($260)));
    };
})(), (function () {
    var $261 = Control_Monad_Fork_Class.suspend(Control_Monad_Fork_Class.monadForkReaderT(Control_Monad_Fork_Class.monadForkAff));
    return function ($262) {
        return Web3($261(unWeb3($262)));
    };
})());
var monadKillWeb3 = new Control_Monad_Fork_Class.MonadKill(function () {
    return monadForkWeb3;
}, function () {
    return monadThrowWeb3;
}, function (e) {
    var $263 = Control_Monad_Fork_Class.kill(Control_Monad_Fork_Class.monadKillReaderT(Control_Monad_Fork_Class.monadKillAff))(e);
    return function ($264) {
        return Web3($263($264));
    };
});
var monadErrorWeb3 = Control_Monad_Reader_Trans.monadErrorReaderT(Effect_Aff.monadErrorAff);
var monadEffectWeb3 = Control_Monad_Reader_Trans.monadEffectReader(Effect_Aff.monadEffectAff);
var throwWeb3 = (function () {
    var $265 = Effect_Class.liftEffect(monadEffectWeb3);
    return function ($266) {
        return $265(Effect_Exception.throwException($266));
    };
})();
var monadBracketWeb3 = new Control_Monad_Fork_Class.MonadBracket(function () {
    return monadErrorWeb3;
}, function () {
    return monadKillWeb3;
}, function (acquire) {
    return function (release) {
        return function (run) {
            return Web3(Control_Monad_Fork_Class.bracket(Control_Monad_Fork_Class.monadBracketReaderT(Control_Monad_Fork_Class.monadBracketAff))(unWeb3(acquire))(function (c) {
                return function (a) {
                    return unWeb3(release(c)(a));
                };
            })(function (a) {
                return unWeb3(run(a));
            }));
        };
    };
}, Control_Monad_Fork_Class.never(Control_Monad_Fork_Class.monadBracketReaderT(Control_Monad_Fork_Class.monadBracketAff)), (function () {
    var $267 = Control_Monad_Fork_Class.uninterruptible(Control_Monad_Fork_Class.monadBracketReaderT(Control_Monad_Fork_Class.monadBracketAff));
    return function ($268) {
        return Web3($267(unWeb3($268)));
    };
})());
var monadAskWeb3 = Control_Monad_Reader_Trans.monadAskReaderT(Effect_Aff.monadAff);
var monadAffWeb3 = Effect_Aff_Class.monadAffReader(Effect_Aff_Class.monadAffAff);
var mkRequest = function (name) {
    return function (reqId) {
        return function (ps) {
            return {
                jsonrpc: "2.0",
                id: reqId,
                method: name,
                params: ps
            };
        };
    };
};
var genericWeb3Error = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Rpc) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof RemoteError) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof ParserError) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof NullError) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 695, column 1 - line 695, column 56): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Rpc(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new RemoteError(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new ParserError(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return NullError.value;
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 695, column 1 - line 695, column 56): " + [ x.constructor.name ]);
});
var genericTxReceipt = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericTransactionStatus = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Succeeded) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Failed) {
        return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 209, column 1 - line 209, column 72): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return Succeeded.value;
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return Failed.value;
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 209, column 1 - line 209, column 72): " + [ x.constructor.name ]);
});
var showTransactionStatus = new Data_Show.Show(Data_Show_Generic.genericShow(genericTransactionStatus)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Succeeded";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Failed";
})))));
var genericTransactionOptions = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showTransactionOptions = new Data_Show.Show(Data_Show_Generic.genericShow(genericTransactionOptions)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "data";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "from";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "gas";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "gasPrice";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "nonce";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "to";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "value";
}))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Network_Ethereum_Web3_Types_TokenUnit.showValue)))(Data_Maybe.showMaybe(Network_Ethereum_Core_Signatures.addressShow)))(Data_Maybe.showMaybe(Network_Ethereum_Core_BigNumber.showBigNumber)))(Data_Maybe.showMaybe(Network_Ethereum_Core_BigNumber.showBigNumber)))(Data_Maybe.showMaybe(Network_Ethereum_Core_BigNumber.showBigNumber)))(Data_Maybe.showMaybe(Network_Ethereum_Core_Signatures.addressShow)))(Data_Maybe.showMaybe(Network_Ethereum_Core_HexString.showHexString)))))(new Data_Symbol.IsSymbol(function () {
    return "TransactionOptions";
}))));
var genericTransaction = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showTransaction = new Data_Show.Show(Data_Show_Generic.genericShow(genericTransaction)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "blockHash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "blockNumber";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "from";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "gas";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "gasPrice";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "hash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "input";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "nonce";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "to";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "transactionIndex";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "value";
}))(Data_Show.showRecordFieldsNil)(Network_Ethereum_Web3_Types_TokenUnit.showValue))(Data_Maybe.showMaybe(Network_Ethereum_Core_BigNumber.showBigNumber)))(Data_Maybe.showMaybe(Network_Ethereum_Core_Signatures.addressShow)))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_Signatures.addressShow))(Data_Maybe.showMaybe(showBlockNumber)))(Data_Maybe.showMaybe(Network_Ethereum_Core_HexString.showHexString)))))(new Data_Symbol.IsSymbol(function () {
    return "Transaction";
}))));
var genericSyncStatus = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showSyncStatus = new Data_Show.Show(Data_Show_Generic.genericShow(genericSyncStatus)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "currentBlock";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "highestBlock";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "startingBlock";
}))(Data_Show.showRecordFieldsNil)(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_BigNumber.showBigNumber))))(new Data_Symbol.IsSymbol(function () {
    return "SyncStatus";
}))));
var genericRpcError = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showRpcError = new Data_Show.Show(Data_Show_Generic.genericShow(genericRpcError)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "code";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "message";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showInt))))(new Data_Symbol.IsSymbol(function () {
    return "RpcError";
}))));
var showWeb3Error = new Data_Show.Show(Data_Show_Generic.genericShow(genericWeb3Error)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRpcError))(new Data_Symbol.IsSymbol(function () {
    return "Rpc";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
    return "RemoteError";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
    return "ParserError";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "NullError";
})))))));
var genericRequest = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericFilterId = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showFilterId = new Data_Show.Show(Data_Show_Generic.genericShow(genericFilterId)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Network_Ethereum_Core_BigNumber.showBigNumber))(new Data_Symbol.IsSymbol(function () {
    return "FilterId";
}))));
var genericFilter = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericFalseOrObj = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericEventAction = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof ContinueEvent) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof TerminateEvent) {
        return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 544, column 1 - line 544, column 60): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return ContinueEvent.value;
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return TerminateEvent.value;
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 544, column 1 - line 544, column 60): " + [ x.constructor.name ]);
});
var showEventAction = new Data_Show.Show(Data_Show_Generic.genericShow(genericEventAction)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "ContinueEvent";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "TerminateEvent";
})))));
var genericChange = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showChange = new Data_Show.Show(Data_Show_Generic.genericShow(genericChange)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "address";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "blockHash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "blockNumber";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "data";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "logIndex";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "removed";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "topics";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "transactionHash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "transactionIndex";
}))(Data_Show.showRecordFieldsNil)(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_HexString.showHexString))(Data_Show.showArray(Network_Ethereum_Core_HexString.showHexString)))(Data_Show.showBoolean))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_HexString.showHexString))(showBlockNumber))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_Signatures.addressShow))))(new Data_Symbol.IsSymbol(function () {
    return "Change";
}))));
var showTxReceipt = new Data_Show.Show(Data_Show_Generic.genericShow(genericTxReceipt)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "blockHash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "blockNumber";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "contractAddress";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "cumulativeGasUsed";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "gasUsed";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "logs";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "status";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "transactionHash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "transactionIndex";
}))(Data_Show.showRecordFieldsNil)(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_HexString.showHexString))(showTransactionStatus))(Data_Show.showArray(showChange)))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_BigNumber.showBigNumber))(Data_Maybe.showMaybe(Network_Ethereum_Core_Signatures.addressShow)))(showBlockNumber))(Network_Ethereum_Core_HexString.showHexString))))(new Data_Symbol.IsSymbol(function () {
    return "TransactionReceipt";
}))));
var genericChainCursor = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Latest) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof BN) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 118, column 1 - line 118, column 60): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return Latest.value;
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new BN(x.value0);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 118, column 1 - line 118, column 60): " + [ x.constructor.name ]);
});
var showChainCursor = new Data_Show.Show(Data_Show_Generic.genericShow(genericChainCursor)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Latest";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showBlockNumber))(new Data_Symbol.IsSymbol(function () {
    return "BN";
})))));
var showFilter = new Data_Show.Show(Data_Show_Generic.genericShow(genericFilter)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "address";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "fromBlock";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "toBlock";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "topics";
}))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Show.showArray(Data_Maybe.showMaybe(Network_Ethereum_Core_HexString.showHexString)))))(showChainCursor))(showChainCursor))(Data_Maybe.showMaybe(Network_Ethereum_Core_Signatures.addressShow)))))(new Data_Symbol.IsSymbol(function () {
    return "Filter";
}))));
var genericCallError = new Data_Generic_Rep.Generic(function (x) {
    return x.value0;
}, function (x) {
    return new NullStorageError(x);
});
var showCallError = new Data_Show.Show(Data_Show_Generic.genericShow(genericCallError)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "_data";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "signature";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Network_Ethereum_Core_HexString.showHexString))))(new Data_Symbol.IsSymbol(function () {
    return "NullStorageError";
}))));
var genericBlockNumber = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericBlock = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showBlock = new Data_Show.Show(Data_Show_Generic.genericShow(genericBlock)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "difficulty";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "extraData";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "gasLimit";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "gasUsed";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "hash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "logsBloom";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "miner";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "nonce";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "number";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "parentHash";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "receiptsRoot";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "sha3Uncles";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "size";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "stateRoot";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "timestamp";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "totalDifficulty";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "transactions";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "transactionsRoot";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "uncles";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showArray(Network_Ethereum_Core_HexString.showHexString)))(Network_Ethereum_Core_HexString.showHexString))(Data_Show.showArray(Network_Ethereum_Core_HexString.showHexString)))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_HexString.showHexString))(Data_Maybe.showMaybe(Network_Ethereum_Core_BigNumber.showBigNumber)))(Data_Maybe.showMaybe(Network_Ethereum_Core_HexString.showHexString)))(Network_Ethereum_Core_HexString.showHexString))(Data_Maybe.showMaybe(Network_Ethereum_Core_HexString.showHexString)))(Data_Maybe.showMaybe(Network_Ethereum_Core_HexString.showHexString)))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_BigNumber.showBigNumber))(Network_Ethereum_Core_HexString.showHexString))(Network_Ethereum_Core_BigNumber.showBigNumber))))(new Data_Symbol.IsSymbol(function () {
    return "Block";
}))));
var functorWeb3Par = Control_Monad_Reader_Trans.functorReaderT(Effect_Aff.functorParAff);
var functorWeb3 = Control_Monad_Reader_Trans.functorReaderT(Effect_Aff.functorAff);
var eqTransactionStatus = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Succeeded && y instanceof Succeeded) {
            return true;
        };
        if (x instanceof Failed && y instanceof Failed) {
            return true;
        };
        return false;
    };
});
var eqTransactionOptions = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_HexString.hexStringEq))(x.data)(y.data) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_Signatures.addressEq))(x.from)(y.from) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_BigNumber.eqBigNumber))(x.gas)(y.gas) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_BigNumber.eqBigNumber))(x.gasPrice)(y.gasPrice) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_BigNumber.eqBigNumber))(x.nonce)(y.nonce) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_Signatures.addressEq))(x.to)(y.to) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Web3_Types_TokenUnit.eqValue))(x.value)(y.value);
    };
});
var eqSyncStatus = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.currentBlock)(y.currentBlock) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.highestBlock)(y.highestBlock) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.startingBlock)(y.startingBlock);
    };
});
var eqRpcError = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericRpcError)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
    return "message";
}))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
    return "code";
}))(Data_Eq.eqInt))))));
var eqWeb3Error = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericWeb3Error)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(eqRpcError)))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqString)))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqString)))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))));
var eqFilterId = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericFilterId)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Network_Ethereum_Core_BigNumber.eqBigNumber))));
var eqFalseOrObj = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(dictEq))(x)(y);
        };
    });
};
var ordFalseOrObj = function (dictOrd) {
    return new Data_Ord.Ord(function () {
        return eqFalseOrObj(dictOrd.Eq0());
    }, function (x) {
        return function (y) {
            return Data_Ord.compare(Data_Maybe.ordMaybe(dictOrd))(x)(y);
        };
    });
};
var eqEventAction = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericEventAction)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))));
var eqCallError = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericCallError)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
    return "signature";
}))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
    return "_data";
}))(Network_Ethereum_Core_HexString.hexStringEq))))));
var eqBlockNumber = Network_Ethereum_Core_BigNumber.eqBigNumber;
var eqChainCursor = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericChainCursor)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(eqBlockNumber)))));
var eqFilter = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericFilter)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
    return "topics";
}))(Data_Maybe.eqMaybe(Data_Eq.eqArray(Data_Maybe.eqMaybe(Network_Ethereum_Core_HexString.hexStringEq)))))()(new Data_Symbol.IsSymbol(function () {
    return "toBlock";
}))(eqChainCursor))()(new Data_Symbol.IsSymbol(function () {
    return "fromBlock";
}))(eqChainCursor))()(new Data_Symbol.IsSymbol(function () {
    return "address";
}))(Data_Maybe.eqMaybe(Network_Ethereum_Core_Signatures.addressEq)))))));
var ordChainCursor = new Data_Ord.Ord(function () {
    return eqChainCursor;
}, function (v) {
    return function (v1) {
        if (v instanceof Latest && v1 instanceof Latest) {
            return Data_Ordering.EQ.value;
        };
        if (v instanceof BN && v1 instanceof BN) {
            return Data_Ord.compare(ordBlockNumber)(v.value0)(v1.value0);
        };
        if (v1 instanceof Latest) {
            return Data_Ordering.LT.value;
        };
        return Data_Ordering.invert(Data_Ord.compare(ordChainCursor)(v1)(v));
    };
});
var eqChange = new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericChange)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
    return "transactionIndex";
}))(Network_Ethereum_Core_BigNumber.eqBigNumber))()(new Data_Symbol.IsSymbol(function () {
    return "transactionHash";
}))(Network_Ethereum_Core_HexString.hexStringEq))()(new Data_Symbol.IsSymbol(function () {
    return "topics";
}))(Data_Eq.eqArray(Network_Ethereum_Core_HexString.hexStringEq)))()(new Data_Symbol.IsSymbol(function () {
    return "removed";
}))(Data_Eq.eqBoolean))()(new Data_Symbol.IsSymbol(function () {
    return "logIndex";
}))(Network_Ethereum_Core_BigNumber.eqBigNumber))()(new Data_Symbol.IsSymbol(function () {
    return "data";
}))(Network_Ethereum_Core_HexString.hexStringEq))()(new Data_Symbol.IsSymbol(function () {
    return "blockNumber";
}))(eqBlockNumber))()(new Data_Symbol.IsSymbol(function () {
    return "blockHash";
}))(Network_Ethereum_Core_HexString.hexStringEq))()(new Data_Symbol.IsSymbol(function () {
    return "address";
}))(Network_Ethereum_Core_Signatures.addressEq))))));
var eqTransaction = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_HexString.hexStringEq))(x.blockHash)(y.blockHash) && Data_Eq.eq(Data_Maybe.eqMaybe(eqBlockNumber))(x.blockNumber)(y.blockNumber) && Data_Eq.eq(Network_Ethereum_Core_Signatures.addressEq)(x.from)(y.from) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.gas)(y.gas) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.gasPrice)(y.gasPrice) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.hash)(y.hash) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.input)(y.input) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.nonce)(y.nonce) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_Signatures.addressEq))(x.to)(y.to) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_BigNumber.eqBigNumber))(x.transactionIndex)(y.transactionIndex) && Data_Eq.eq(Network_Ethereum_Web3_Types_TokenUnit.eqValue)(x.value)(y.value);
    };
});
var eqTxReceipt = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.blockHash)(y.blockHash) && Data_Eq.eq(eqBlockNumber)(x.blockNumber)(y.blockNumber) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_Signatures.addressEq))(x.contractAddress)(y.contractAddress) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.cumulativeGasUsed)(y.cumulativeGasUsed) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.gasUsed)(y.gasUsed) && Data_Eq.eq(Data_Eq.eqArray(eqChange))(x.logs)(y.logs) && Data_Eq.eq(eqTransactionStatus)(x.status)(y.status) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.transactionHash)(y.transactionHash) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.transactionIndex)(y.transactionIndex);
    };
});
var eqBlock = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.difficulty)(y.difficulty) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.extraData)(y.extraData) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.gasLimit)(y.gasLimit) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.gasUsed)(y.gasUsed) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_HexString.hexStringEq))(x.hash)(y.hash) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_HexString.hexStringEq))(x.logsBloom)(y.logsBloom) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.miner)(y.miner) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_HexString.hexStringEq))(x.nonce)(y.nonce) && Data_Eq.eq(Data_Maybe.eqMaybe(Network_Ethereum_Core_BigNumber.eqBigNumber))(x.number)(y.number) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.parentHash)(y.parentHash) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.receiptsRoot)(y.receiptsRoot) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.sha3Uncles)(y.sha3Uncles) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.size)(y.size) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.stateRoot)(y.stateRoot) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.timestamp)(y.timestamp) && Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(x.totalDifficulty)(y.totalDifficulty) && Data_Eq.eq(Data_Eq.eqArray(Network_Ethereum_Core_HexString.hexStringEq))(x.transactions)(y.transactions) && Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(x.transactionsRoot)(y.transactionsRoot) && Data_Eq.eq(Data_Eq.eqArray(Network_Ethereum_Core_HexString.hexStringEq))(x.uncles)(y.uncles);
    };
});
var encodeTransactionOptions = new Foreign_Generic_Class.Encode(function (v) {
    var encodeMaybe = function (dictEncode) {
        return Data_Maybe.maybe(Foreign_NullOrUndefined["undefined"])(Foreign_Generic_Class.encode(dictEncode));
    };
    return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("from")(encodeMaybe(Network_Ethereum_Core_Signatures.encodeAddress)(v.from)), Data_Tuple.Tuple.create("to")(encodeMaybe(Network_Ethereum_Core_Signatures.encodeAddress)(v.to)), Data_Tuple.Tuple.create("value")(encodeMaybe(Network_Ethereum_Web3_Types_TokenUnit.encodeValue)(v.value)), Data_Tuple.Tuple.create("gas")(encodeMaybe(Network_Ethereum_Core_BigNumber.encodeBigNumber)(v.gas)), Data_Tuple.Tuple.create("gasPrice")(encodeMaybe(Network_Ethereum_Core_BigNumber.encodeBigNumber)(v.gasPrice)), Data_Tuple.Tuple.create("data")(encodeMaybe(Network_Ethereum_Core_HexString.encodeHexString)(v.data)), Data_Tuple.Tuple.create("nonce")(encodeMaybe(Network_Ethereum_Core_BigNumber.encodeBigNumber)(v.nonce)) ]));
});
var encodeRpcError = new Foreign_Generic_Class.Encode(function (x) {
    return Foreign_Generic.genericEncode(genericRpcError)(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "RpcError";
    }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "message";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(new Data_Symbol.IsSymbol(function () {
        return "code";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var encodeRequest = new Foreign_Generic_Class.Encode(function (x) {
    return Foreign_Generic.genericEncode(genericRequest)(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Request";
    }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "params";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.foreignEncode))))(new Data_Symbol.IsSymbol(function () {
        return "method";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(new Data_Symbol.IsSymbol(function () {
        return "jsonrpc";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(new Data_Symbol.IsSymbol(function () {
        return "id";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var encodeJsonBlockNumber = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    return Data_Argonaut_Encode_Class.encodeJson(Network_Ethereum_Core_BigNumber.encodeJsonBigNumber)(v);
});
var encodeFilterId = new Foreign_Generic_Class.Encode(function (x) {
    return Foreign_Generic.genericEncode(genericFilterId)(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "FilterId";
    }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Network_Ethereum_Core_BigNumber.encodeBigNumber))))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var encodeBlockNumber = Network_Ethereum_Core_BigNumber.encodeBigNumber;
var encodeChainCursor = new Foreign_Generic_Class.Encode(function (cm) {
    if (cm instanceof Latest) {
        return Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("latest");
    };
    if (cm instanceof BN) {
        return Foreign_Generic_Class.encode(encodeBlockNumber)(cm.value0);
    };
    throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 133, column 15 - line 135, column 21): " + [ cm.constructor.name ]);
});
var encodeFilter = new Foreign_Generic_Class.Encode(function (x) {
    return Foreign_Generic.genericEncode(genericFilter)(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Filter";
    }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "topics";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.maybeEncode(Network_Ethereum_Core_HexString.encodeHexString))))))(new Data_Symbol.IsSymbol(function () {
        return "toBlock";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(encodeChainCursor)))(new Data_Symbol.IsSymbol(function () {
        return "fromBlock";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(encodeChainCursor)))(new Data_Symbol.IsSymbol(function () {
        return "address";
    }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Network_Ethereum_Core_Signatures.encodeAddress)))))))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var defaultTransactionOptions = {
    from: Data_Maybe.Nothing.value,
    to: Data_Maybe.Nothing.value,
    value: Data_Maybe.Nothing.value,
    gas: Data_Maybe.Nothing.value,
    gasPrice: Data_Maybe.Nothing.value,
    data: Data_Maybe.Nothing.value,
    nonce: Data_Maybe.Nothing.value
};
var defaultFilter = {
    address: Data_Maybe.Nothing.value,
    topics: Data_Maybe.Nothing.value,
    fromBlock: Latest.value,
    toBlock: Latest.value
};
var decodeTransactionStatus = new Foreign_Generic_Class.Decode(function (x) {
    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign.readString(Data_Identity.monadIdentity)(x))(function (str) {
        if (str === "0x1") {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Succeeded.value);
        };
        if (str === "0x0") {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Failed.value);
        };
        return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.TypeMismatch("TransactionStatus", str));
    });
});
var decodeSyncStatus = new Foreign_Generic_Class.Decode(Foreign_Generic.genericDecode(genericSyncStatus)(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
    return "SyncStatus";
}))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "startingBlock";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
    return "highestBlock";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
    return "currentBlock";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())))(Foreign_Generic_Class.genericCountArgsArgument))({
    sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
    fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
}));
var decodeRpcError = new Foreign_Generic_Class.Decode(function (x) {
    return Foreign_Generic.genericDecode(genericRpcError)(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "RpcError";
    }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "message";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())(new Data_Symbol.IsSymbol(function () {
        return "code";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var decodeWeb3Error = new Foreign_Generic_Class.Decode(function (x) {
    var nullParser = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.readProp(Data_Identity.monadIdentity)("result")(x))(function (res) {
        var $222 = Foreign.isNull(res);
        if ($222) {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(NullError.value);
        };
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign.readString(Data_Identity.monadIdentity)(res))(function (r) {
            return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.TypeMismatch("NullError", r));
        });
    });
    return Control_Alt.alt(Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Rpc.create)(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.readProp(Data_Identity.monadIdentity)("error")(x))(Foreign_Generic_Class.decode(decodeRpcError))))(nullParser);
});
var runWeb3 = function (p) {
    return function (v) {
        var parseMsg = function (msg) {
            return Control_Error_Util.hush(Control_Monad_Except.runExcept(Foreign_Generic.genericDecodeJSON(genericWeb3Error)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "Rpc";
            }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(decodeRpcError)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "RemoteError";
            }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "ParserError";
            }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "NullError";
            }))(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))(Foreign_Generic_Class.defaultOptions)(msg)));
        };
        return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Aff.attempt(Control_Monad_Reader_Trans.runReaderT(v)(p)))(function (v1) {
            if (v1 instanceof Data_Either.Left) {
                return Data_Maybe.maybe(Control_Monad_Error_Class.throwError(Effect_Aff.monadThrowAff)(v1.value0))((function () {
                    var $269 = Control_Applicative.pure(Effect_Aff.applicativeAff);
                    return function ($270) {
                        return $269(Data_Either.Left.create($270));
                    };
                })())(parseMsg(Effect_Exception.message(v1.value0)));
            };
            if (v1 instanceof Data_Either.Right) {
                return Control_Applicative.pure(Effect_Aff.applicativeAff)(new Data_Either.Right(v1.value0));
            };
            throw new Error("Failed pattern match at Network.Ethereum.Web3.Types.Types (line 435, column 9 - line 437, column 34): " + [ v1.constructor.name ]);
        });
    };
};
var forkWeb3 = function (p) {
    var $271 = runWeb3(p);
    return function ($272) {
        return Effect_Aff.forkAff($271($272));
    };
};
var decodeResponse$prime = function (dictDecode) {
    return new Foreign_Generic_Class.Decode(function (a) {
        return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Response)(Control_Alt.alt(Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Either.Left.create)(Foreign_Generic_Class.decode(decodeWeb3Error)(a)))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Either.Right.create)(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.readProp(Data_Identity.monadIdentity)("result")(a))(Foreign_Generic_Class.decode(dictDecode)))));
    });
};
var decodeJsonBlockNumber = new Data_Argonaut_Decode_Class.DecodeJson((function () {
    var $273 = Data_Functor.map(Data_Either.functorEither)(BlockNumber);
    var $274 = Data_Argonaut_Decode_Class.decodeJson(Network_Ethereum_Core_BigNumber.decodeJsonBigNumber);
    return function ($275) {
        return $273($274($275));
    };
})());
var decodeFilterId = new Foreign_Generic_Class.Decode(function (x) {
    return Foreign_Generic.genericDecode(genericFilterId)(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "FilterId";
    }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber)))(Foreign_Generic_Class.genericCountArgsArgument))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var decodeFalseOrObj = function (dictDecode) {
    return new Foreign_Generic_Class.Decode(function (x) {
        return readFalseOrObject(Foreign_Generic_Class.decode(dictDecode))(x);
    });
};
var decodeBlockNumber = Network_Ethereum_Core_BigNumber.decodeBigNumber;
var decodeChange = new Foreign_Generic_Class.Decode(function (x) {
    return Foreign_Generic.genericDecode(genericChange)(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Change";
    }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "transactionIndex";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "transactionHash";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "topics";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Network_Ethereum_Core_HexString.decodeHexString)))())(new Data_Symbol.IsSymbol(function () {
        return "removed";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())(new Data_Symbol.IsSymbol(function () {
        return "logIndex";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "data";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "blockNumber";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(decodeBlockNumber))())(new Data_Symbol.IsSymbol(function () {
        return "blockHash";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "address";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_Signatures.decodeAddress))())))(Foreign_Generic_Class.genericCountArgsArgument))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var decodeTransaction = new Foreign_Generic_Class.Decode(function (x) {
    return Foreign_Generic.genericDecode(genericTransaction)(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Transaction";
    }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "value";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Web3_Types_TokenUnit.decodeValue))())(new Data_Symbol.IsSymbol(function () {
        return "transactionIndex";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_BigNumber.decodeBigNumber)))())(new Data_Symbol.IsSymbol(function () {
        return "to";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_Signatures.decodeAddress)))())(new Data_Symbol.IsSymbol(function () {
        return "nonce";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "input";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "hash";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "gasPrice";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "gas";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "from";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_Signatures.decodeAddress))())(new Data_Symbol.IsSymbol(function () {
        return "blockNumber";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(decodeBlockNumber)))())(new Data_Symbol.IsSymbol(function () {
        return "blockHash";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_HexString.decodeHexString)))())))(Foreign_Generic_Class.genericCountArgsArgument))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var decodeTxReceipt = new Foreign_Generic_Class.Decode(Foreign_Generic.genericDecode(genericTxReceipt)(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
    return "TransactionReceipt";
}))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "transactionIndex";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
    return "transactionHash";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
    return "status";
}))(Foreign_Generic_Class.decodeWithOptionsOther(decodeTransactionStatus))())(new Data_Symbol.IsSymbol(function () {
    return "logs";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(decodeChange)))())(new Data_Symbol.IsSymbol(function () {
    return "gasUsed";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
    return "cumulativeGasUsed";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
    return "contractAddress";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_Signatures.decodeAddress)))())(new Data_Symbol.IsSymbol(function () {
    return "blockNumber";
}))(Foreign_Generic_Class.decodeWithOptionsOther(decodeBlockNumber))())(new Data_Symbol.IsSymbol(function () {
    return "blockHash";
}))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())))(Foreign_Generic_Class.genericCountArgsArgument))({
    sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
    fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
}));
var decodeBlock = new Foreign_Generic_Class.Decode(function (x) {
    return Foreign_Generic.genericDecode(genericBlock)(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Block";
    }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "uncles";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Network_Ethereum_Core_HexString.decodeHexString)))())(new Data_Symbol.IsSymbol(function () {
        return "transactionsRoot";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "transactions";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Network_Ethereum_Core_HexString.decodeHexString)))())(new Data_Symbol.IsSymbol(function () {
        return "totalDifficulty";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "timestamp";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "stateRoot";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "size";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "sha3Uncles";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "receiptsRoot";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "parentHash";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "number";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_BigNumber.decodeBigNumber)))())(new Data_Symbol.IsSymbol(function () {
        return "nonce";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_HexString.decodeHexString)))())(new Data_Symbol.IsSymbol(function () {
        return "miner";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "logsBloom";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_HexString.decodeHexString)))())(new Data_Symbol.IsSymbol(function () {
        return "hash";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Network_Ethereum_Core_HexString.decodeHexString)))())(new Data_Symbol.IsSymbol(function () {
        return "gasUsed";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "gasLimit";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())(new Data_Symbol.IsSymbol(function () {
        return "extraData";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_HexString.decodeHexString))())(new Data_Symbol.IsSymbol(function () {
        return "difficulty";
    }))(Foreign_Generic_Class.decodeWithOptionsOther(Network_Ethereum_Core_BigNumber.decodeBigNumber))())))(Foreign_Generic_Class.genericCountArgsArgument))({
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    })(x);
});
var bindWeb3 = Control_Monad_Reader_Trans.bindReaderT(Effect_Aff.bindAff);
var forkWeb3$prime = function (web3Action) {
    return Control_Bind.bind(bindWeb3)(Control_Monad_Reader_Class.ask(monadAskWeb3))(function (p) {
        return Effect_Aff_Class.liftAff(monadAffWeb3)(forkWeb3(p)(web3Action));
    });
};
var applyWeb3Par = Control_Monad_Reader_Trans.applyReaderT(Effect_Aff.applyParAff);
var applyWeb3 = Control_Monad_Reader_Trans.applyReaderT(Effect_Aff.applyAff);
var applicativeWeb3Par = Control_Monad_Reader_Trans.applicativeReaderT(Effect_Aff.applicativeParAff);
var monadParWeb3 = new Control_Parallel_Class.Parallel(function () {
    return applicativeWeb3Par;
}, function () {
    return monadWeb3;
}, function (v) {
    return Control_Parallel_Class.parallel(Control_Parallel_Class.monadParReaderT(Effect_Aff.parallelAff))(v);
}, function (v) {
    return Control_Parallel_Class.sequential(Control_Parallel_Class.monadParReaderT(Effect_Aff.parallelAff))(v);
});
var applicativeWeb3 = Control_Monad_Reader_Trans.applicativeReaderT(Effect_Aff.applicativeAff);
var lazyWeb3 = new Control_Lazy.Lazy(function (f) {
    return Control_Bind.bind(bindWeb3)(Control_Applicative.pure(applicativeWeb3)(Data_Unit.unit))(f);
});
var alternativeParWeb3 = Control_Monad_Reader_Trans.alternativeReaderT(Effect_Aff.alternativeParAff);
var altParWeb3 = Control_Monad_Reader_Trans.altReaderT(Effect_Aff.altParAff);
var _value = function (dictTokenUnit) {
    return function (dictStrong) {
        return Data_Lens_Lens.lens(function (v) {
            return v.value;
        })(function (v) {
            return function (val) {
                return TransactionOptions({
                    from: v.from,
                    to: v.to,
                    value: Data_Functor.map(Data_Maybe.functorMaybe)(Network_Ethereum_Web3_Types_TokenUnit.convert(Network_Ethereum_Web3_Types_TokenUnit.unitTokenUnitSpec(Network_Ethereum_Web3_Types_TokenUnit.unitSpecMinorUnit))(Network_Ethereum_Web3_Types_TokenUnit.unitTokenUnitSpec(Network_Ethereum_Web3_Types_TokenUnit.unitSpecMinorUnit)))(val),
                    gas: v.gas,
                    gasPrice: v.gasPrice,
                    data: v.data,
                    nonce: v.nonce
                });
            };
        })(dictStrong);
    };
};
var _topics = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.topics;
    })(function (v) {
        return function (ts) {
            return Filter({
                address: v.address,
                topics: ts,
                fromBlock: v.fromBlock,
                toBlock: v.toBlock
            });
        };
    })(dictStrong);
};
var _toBlock = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.toBlock;
    })(function (v) {
        return function (b) {
            return Filter({
                address: v.address,
                topics: v.topics,
                fromBlock: v.fromBlock,
                toBlock: b
            });
        };
    })(dictStrong);
};
var _to = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.to;
    })(function (v) {
        return function (addr) {
            return TransactionOptions({
                from: v.from,
                to: addr,
                value: v.value,
                gas: v.gas,
                gasPrice: v.gasPrice,
                data: v.data,
                nonce: v.nonce
            });
        };
    })(dictStrong);
};
var _nonce = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.nonce;
    })(function (v) {
        return function (n) {
            return TransactionOptions({
                from: v.from,
                to: v.to,
                value: v.value,
                gas: v.gas,
                gasPrice: v.gasPrice,
                data: v.data,
                nonce: n
            });
        };
    })(dictStrong);
};
var _gasPrice = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.gasPrice;
    })(function (v) {
        return function (gp) {
            return TransactionOptions({
                from: v.from,
                to: v.to,
                value: v.value,
                gas: v.gas,
                gasPrice: gp,
                data: v.data,
                nonce: v.nonce
            });
        };
    })(dictStrong);
};
var _gas = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.gas;
    })(function (v) {
        return function (g) {
            return TransactionOptions({
                from: v.from,
                to: v.to,
                value: v.value,
                gas: g,
                gasPrice: v.gasPrice,
                data: v.data,
                nonce: v.nonce
            });
        };
    })(dictStrong);
};
var _fromBlock = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.fromBlock;
    })(function (v) {
        return function (b) {
            return Filter({
                address: v.address,
                topics: v.topics,
                fromBlock: b,
                toBlock: v.toBlock
            });
        };
    })(dictStrong);
};
var _from = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.from;
    })(function (v) {
        return function (addr) {
            return TransactionOptions({
                from: addr,
                to: v.to,
                value: v.value,
                gas: v.gas,
                gasPrice: v.gasPrice,
                data: v.data,
                nonce: v.nonce
            });
        };
    })(dictStrong);
};
var _data = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.data;
    })(function (v) {
        return function (dat) {
            return TransactionOptions({
                from: v.from,
                to: v.to,
                value: v.value,
                gas: v.gas,
                gasPrice: v.gasPrice,
                data: dat,
                nonce: v.nonce
            });
        };
    })(dictStrong);
};
var _address = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.address;
    })(function (v) {
        return function (addr) {
            return Filter({
                address: addr,
                topics: v.topics,
                fromBlock: v.fromBlock,
                toBlock: v.toBlock
            });
        };
    })(dictStrong);
};
module.exports = {
    BlockNumber: BlockNumber,
    Latest: Latest,
    BN: BN,
    Block: Block,
    Transaction: Transaction,
    TransactionReceipt: TransactionReceipt,
    Succeeded: Succeeded,
    Failed: Failed,
    TransactionOptions: TransactionOptions,
    defaultTransactionOptions: defaultTransactionOptions,
    "_from": _from,
    "_to": _to,
    "_data": _data,
    "_value": _value,
    "_gas": _gas,
    "_gasPrice": _gasPrice,
    "_nonce": _nonce,
    forkWeb3: forkWeb3,
    "forkWeb3'": forkWeb3$prime,
    runWeb3: runWeb3,
    Web3: Web3,
    throwWeb3: throwWeb3,
    defaultFilter: defaultFilter,
    "_address": _address,
    "_topics": _topics,
    "_fromBlock": _fromBlock,
    "_toBlock": _toBlock,
    ContinueEvent: ContinueEvent,
    TerminateEvent: TerminateEvent,
    Change: Change,
    FalseOrObject: FalseOrObject,
    unFalseOrObject: unFalseOrObject,
    SyncStatus: SyncStatus,
    mkRequest: mkRequest,
    Response: Response,
    Rpc: Rpc,
    RemoteError: RemoteError,
    ParserError: ParserError,
    NullError: NullError,
    RpcError: RpcError,
    NullStorageError: NullStorageError,
    genericBlockNumber: genericBlockNumber,
    showBlockNumber: showBlockNumber,
    eqBlockNumber: eqBlockNumber,
    ordBlockNumber: ordBlockNumber,
    decodeBlockNumber: decodeBlockNumber,
    encodeBlockNumber: encodeBlockNumber,
    newtypeBlockNumber: newtypeBlockNumber,
    encodeJsonBlockNumber: encodeJsonBlockNumber,
    decodeJsonBlockNumber: decodeJsonBlockNumber,
    readFHexString: readFHexString,
    writeFHexString: writeFHexString,
    genericChainCursor: genericChainCursor,
    eqChainCursor: eqChainCursor,
    showChainCursor: showChainCursor,
    ordChainCursor: ordChainCursor,
    encodeChainCursor: encodeChainCursor,
    genericBlock: genericBlock,
    newtypeBlock: newtypeBlock,
    eqBlock: eqBlock,
    showBlock: showBlock,
    decodeBlock: decodeBlock,
    genericTransaction: genericTransaction,
    newtypeTransaction: newtypeTransaction,
    eqTransaction: eqTransaction,
    showTransaction: showTransaction,
    decodeTransaction: decodeTransaction,
    genericTransactionStatus: genericTransactionStatus,
    eqTransactionStatus: eqTransactionStatus,
    showTransactionStatus: showTransactionStatus,
    decodeTransactionStatus: decodeTransactionStatus,
    genericTxReceipt: genericTxReceipt,
    newtypeTxReceipt: newtypeTxReceipt,
    eqTxReceipt: eqTxReceipt,
    showTxReceipt: showTxReceipt,
    decodeTxReceipt: decodeTxReceipt,
    genericTransactionOptions: genericTransactionOptions,
    newtypeTransactionOptions: newtypeTransactionOptions,
    eqTransactionOptions: eqTransactionOptions,
    showTransactionOptions: showTransactionOptions,
    encodeTransactionOptions: encodeTransactionOptions,
    genericSyncStatus: genericSyncStatus,
    newtypeSyncStatus: newtypeSyncStatus,
    eqSyncStatus: eqSyncStatus,
    decodeSyncStatus: decodeSyncStatus,
    showSyncStatus: showSyncStatus,
    functorWeb3: functorWeb3,
    applyWeb3: applyWeb3,
    applicativeWeb3: applicativeWeb3,
    bindWeb3: bindWeb3,
    monadWeb3: monadWeb3,
    monadEffectWeb3: monadEffectWeb3,
    monadAffWeb3: monadAffWeb3,
    monadThrowWeb3: monadThrowWeb3,
    monadErrorWeb3: monadErrorWeb3,
    monadAskWeb3: monadAskWeb3,
    monadReaderWeb3: monadReaderWeb3,
    monadRecWeb3: monadRecWeb3,
    lazyWeb3: lazyWeb3,
    monadForkWeb3: monadForkWeb3,
    monadKillWeb3: monadKillWeb3,
    monadBracketWeb3: monadBracketWeb3,
    functorWeb3Par: functorWeb3Par,
    applyWeb3Par: applyWeb3Par,
    applicativeWeb3Par: applicativeWeb3Par,
    monadParWeb3: monadParWeb3,
    altParWeb3: altParWeb3,
    plusParWeb3: plusParWeb3,
    alternativeParWeb3: alternativeParWeb3,
    genericFilter: genericFilter,
    newtypeFilter: newtypeFilter,
    showFilter: showFilter,
    eqFilter: eqFilter,
    encodeFilter: encodeFilter,
    genericFilterId: genericFilterId,
    showFilterId: showFilterId,
    eqFilterId: eqFilterId,
    encodeFilterId: encodeFilterId,
    decodeFilterId: decodeFilterId,
    genericEventAction: genericEventAction,
    showEventAction: showEventAction,
    eqEventAction: eqEventAction,
    genericChange: genericChange,
    newtypeChange: newtypeChange,
    showChange: showChange,
    eqChange: eqChange,
    decodeChange: decodeChange,
    newtypeFalseOrObj: newtypeFalseOrObj,
    eqFalseOrObj: eqFalseOrObj,
    ordFalseOrObj: ordFalseOrObj,
    genericFalseOrObj: genericFalseOrObj,
    showFalseOrObj: showFalseOrObj,
    decodeFalseOrObj: decodeFalseOrObj,
    genericRequest: genericRequest,
    encodeRequest: encodeRequest,
    "decodeResponse'": decodeResponse$prime,
    genericCallError: genericCallError,
    showCallError: showCallError,
    eqCallError: eqCallError,
    newtypeRPCError: newtypeRPCError,
    genericRpcError: genericRpcError,
    showRpcError: showRpcError,
    eqRpcError: eqRpcError,
    decodeRpcError: decodeRpcError,
    encodeRpcError: encodeRpcError,
    genericWeb3Error: genericWeb3Error,
    showWeb3Error: showWeb3Error,
    eqWeb3Error: eqWeb3Error,
    decodeWeb3Error: decodeWeb3Error
};
